import type { StringSchema } from 'yup';
import * as yup from 'yup';

import { OPERATION_NAME_MAX_LENGTH } from '@nora-monorepo/shared';

type Translate = (key: string, params?: unknown) => string;

/**
 * Creates the yup schema for operation names.
 *
 * The translation function is provided by the caller so schema creation can use
 * the component's active i18n context instead of a module-level translated string.
 */
export function createOperationNameSchema(t: Translate): StringSchema<string | undefined> {
  return yup
    .string()
    .trim()
    .required(t('operation.validation.operationNameRequired'))
    .max(
      OPERATION_NAME_MAX_LENGTH,
      t('operation.validation.operationNameMaxLengthExceeded', [OPERATION_NAME_MAX_LENGTH]),
    );
}
